import React, { useRef, useState } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonHeader, IonContent, IonGrid, IonRow, IonCol, IonText, IonFooter} from '@ionic/react';

import {Application_SubmissionModal} from './Modal_Application_Submission';

import '../../css/layout.css';

export function JobDescriptionModal(props) {

    let [requisition_id, setRequisition_id] = useState(props.data.requisitionID);
    let [requisition_name, setRequisition_name] = useState(props.data.requisitionName);
    let [jobResponsibilites, setJobResponsibilites] = useState(props.data.requisitionResponsibilites);
    let [applicantQualifications, setApplicantQualifications] = useState(props.data.requisitionQualifications);
    let [applicantDeadline, setApplicantDeadline] = useState(props.data.requisitionDeadline);

    let [showApplicationSubmissionnModal, setShowApplicationSubmissionnModal] = useState(false);



    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'> <IonText> {requisition_name}</IonText> </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'><IonText> Req ID: {requisition_id} </IonText></IonCol>
                        <IonCol size='6'><IonText> Deadline: {applicantDeadline} </IonText></IonCol>
                    </IonRow>
                </IonGrid >  
            </IonHeader>

            <IonContent className='appContent'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h3>Responsibilities</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <p>
                                    {jobResponsibilites}
                            </p>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size='12'>
                            <h3>Qualifications</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <p>
                             {applicantQualifications}

                            </p>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>

            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonCol>
                        <IonButton onClick={closeModalHandler}>Cancel </IonButton>
                        <IonButton onClick={() => setShowApplicationSubmissionnModal(true)}>Apply </IonButton>
                    </IonCol>
                </IonGrid>
            </IonFooter>
            <Application_SubmissionModal openModal={ showApplicationSubmissionnModal } closeModal={() => setShowApplicationSubmissionnModal(false)} data={{
                    requisitionID: requisition_id, 
                    requisitionName: requisition_name,
                                        }}></Application_SubmissionModal>

        </IonModal>
        ) : null}
    </React.Fragment>
    )
}
